import * as GatewayServer from './server.js';
export {GatewayServer};
export default GatewayServer.Factory;
